import { hostingToneDotClass } from 'dashboard/helper/channelHostingStatus';

export function isMessengerInbox(inbox) {
  return inbox?.channel_type === 'Channel::FacebookPage';
}

export function messengerAuthTone(inbox) {
  if (!isMessengerInbox(inbox)) return null;
  return inbox.reauthorization_required ? 'bad' : 'ok';
}

export function messengerAuthDotClass(inbox) {
  const tone = messengerAuthTone(inbox);
  return tone ? hostingToneDotClass(tone) : null;
}

export function messengerAuthTooltipKey(inbox) {
  const tone = messengerAuthTone(inbox);
  if (tone === 'bad') return 'CUSTOM.MESSENGER_AUTH.BAD';
  if (tone === 'ok') return 'CUSTOM.MESSENGER_AUTH.OK';
  return null;
}
